const fieldNames = {
  files: 'files',
  type: 'alertTypeId',
  startDate: 'startDate',
  reason: 'alertReasonId',
  responsible: 'executorIds',
  planEndDate: 'planEndDate',
  initiators: 'initiators',
  endDate: 'endDate',
  description: 'description',
  alisaTemplate: 'alisaTemplate',
  alisaText: 'alisaText',
  addresses: 'addresses',
  notifyTo: 'notifyTo',
  enableAlisa: 'enableAlisa',
  isIVRForServiceCompany: 'isIVRForServiceCompany',
  city: 'cityId',
  mainInitiator: 'mainInitiator',
  company: 'serviceCompanyId',
  flatCount: 'flatCount',
};

const dateFields = new Set([
  fieldNames.startDate,
  fieldNames.endDate,
  fieldNames.planEndDate,
]);

const changeModalWithInfoBodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export { fieldNames, dateFields, changeModalWithInfoBodyStyle };
